import React, { useState } from 'react';
import './QueryEditor.css';

const QueryEditor: React.FC = () => {
  const [query, setQuery] = useState<string>('');
  const [results, setResults] = useState<any[]>([]);
  const [error, setError] = useState<string>('');
  const [loading, setLoading] = useState(false);
  const [rowsAffected, setRowsAffected] = useState<number[]>([]);

  const executeQuery = async () => {
    if (!query.trim()) {
      setError('Please enter a query');
      return;
    }

    setLoading(true);
    setError('');
    try {
      const response = await fetch('http://localhost:5000/api/query', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ query }),
      });

      if (!response.ok) throw new Error('Query execution failed');

      const data = await response.json();
      setResults(data.recordset || []);
      setRowsAffected(data.rowsAffected || []);
    } catch (err) {
      setError('Error: ' + (err as Error).message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="query-editor">
      <h2>SQL Query Editor</h2>

      <div className="query-input">
        <textarea
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          placeholder="Enter your SQL query here..."
          rows={8}
        />
        <button
          onClick={executeQuery}
          disabled={loading}
          className="execute-btn"
        >
          {loading ? 'Executing...' : 'Execute Query'}
        </button>
      </div>

      {error && (
        <div className="error">
          {error}
          <button onClick={() => setError('')}>Dismiss</button>
        </div>
      )}

      {rowsAffected.length > 0 && (
        <div className="rows-affected">
          Rows affected: {rowsAffected.join(', ')}
        </div>
      )}

      {results.length > 0 && (
        <div className="results">
          <h3>Results</h3>
          <div className="results-table-container">
            <table className="results-table">
              <thead>
                <tr>
                  {Object.keys(results[0]).map((key) => (
                    <th key={key}>{key}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {results.map((row, index) => (
                  <tr key={index}>
                    {Object.values(row).map((value: any, idx) => (
                      <td key={idx}>
                        {value !== null && value !== undefined ? String(value) : ''}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
};

export default QueryEditor;